const Signup = () => {
    return <div>Sign Up</div>
}
export default Signup